export const UPDATE_AVAILABILITY_SLOT = "UPDATE_AVAILABILITY_SLOT"
export const REJECT_ALLAPPOINTMENTS = "REJECT_ALLAPPOINTMENTS"
export const APPOINTMENT_SCHEDULE = "APPOINTMENT_SCHEDULE"
export const CANCEL_APPOINTMENT = "CANCEL_APPOINTMENT"
export const APPOINTMENT_REJECT = "APPOINTMENT_REJECT"
export const REJECT_APPOINTMENT = "REJECT_APPOINTMENT"
export const TESTIMONIAL_VIDEO = "TESTIMONIAL_VIDEO"
export const APPOINTMENT_SLOTS = "APPOINTMENT_SLOTS"
export const DAILY_CHAT_WARN = "DAILY_CHAT_WARN"
export const DELETE_SCHEDULE = "DELETE_SCHEDULE"
export const COMMENT_REPORT = "COMMENT_REPORT"
export const CREATE_BOOKING = "CREATE_BOOKING"
export const WEBINAR_CREATE = "WEBINAR_CREATE"
export const EDIT_TIME_SLOT = "EDIT_TIME_SLOT"
export const ADD_EXCEPTION = "ADD_EXCEPTION"
export const MANAGE_COOKIE = "MANAGE_COOKIE"
export const FORUM_REPORT = "FORUM_REPORT"
export const DELETE_FORUM = "DELETE_FORUM"
export const GUEST_SIGNUP = "GUEST_SIGNUP"
export const CHECK_EMAIL = "CHECK_EMAIL"
export const GUEST_LOGIN = "GUEST_LOGIN"
export const UPLOAD_DOC = "UPLOAD_DOC"
export const FOLLOW_UP = "FOLLOW_UP"
export const APPOINTMENT_COMPLETE_POPUP = "APPOINTMENT_COMPLETE_POPUP"
export const APPOINTMENT_CANCEL_CONFIRM = "APPOINTMENT_CANCEL_CONFIRM"
export const SUBSCRIPTION_CHECKOUT = "SUBSCRIPTION_CHECKOUT";
export const FEATURE_GUARD = "FEATURE_GUARD";
export const APPOINTMENT_DETAILS = "APPOINTMENT_DETAILS";
